/* global FS, TD, gRootURL, gApiConfig, printJS */

import $ from "jquery";
import "./print.js";

function generateDocument(progress, url) {
	FS.addScript(gRootURL + "/js/jquery-signalR-2.4.3.min.js", function () {
		generateDocumentImpl(progress, url);
	});
}

function generateDocumentImpl(progress, url) {
	progress = $(progress);

	function complete(i) {
		$("button", progress).text(TD.Res["action.done"]);
		if (i === 1000001) {
			$("p", progress).text(TD.Res["document.error.no_records"]);
		} else {
			$("p", progress).text(TD.Res["document.download"]);
			setTimeout(function () {
				location.href = gApiConfig.backUrl;
			}, 3000);
		}
	}

	function download(url) {
		var ifr = $("<iframe>", { id: "td-downloader", src: url });
		ifr.on("load", function () { setTimeout(function () { complete(); }, 1000);	});
		ifr.insertAfter(progress);
	}

	$("button", progress).on("click", function() {
		location.href = gApiConfig.backUrl;
	});

	var appid = /\/db\/(\d+(-\d+)?)\//i.exec(url.substring(0, url.indexOf("?") + 1))[1];
	var did = $.qstring(url.substring(url.indexOf("?") + 1)).get("d") * 1;
	var currentTaskId = "doc-" + did + "-" + new Date().valueOf();

	var hubConnectionOptions = { logging: false, qs: { "teamdesk-database-id": appid }};
	var connection = $.hubConnection(gRootURL, hubConnectionOptions);
	connection.createHubProxy("progressHub")
	.on("notifyProgress", function(taskId, i, l) {
		if(currentTaskId === taskId) {
			var p = l ? (i / l * 100) : 0;
			if(i < 999999) {
				$("div.ui-progressmeter", progress).css("width", p + "%");
				$("div.ui-progressvalue", progress).text(p.toFixed(0) + "%");
				$("#td-progress-output").text(String.format(TD.Res["action.progress_text"], i, l));
			}
			else if(i === 999999) {
				$("p", progress).text(TD.Res["document.rendering"]);
			} else {
				complete(i);
			}
		}
	});
	var connectionOptions = {};
	connection.start(connectionOptions)
	.done(function() {
		var connectionId = connection.id;
		download(url + "&task=" + encodeURIComponent(currentTaskId) + "&conn=" + encodeURIComponent(connectionId));
	})
	.fail(function() {
		$(".ui-progressvalue", progress).text(TD.Res["document.error.no_progress"]);
		$("p", progress).empty();
		download(url);
	});
}

var printModal;

function addPrintModal() {
	if (!printModal) {
		printModal = $("<div>", { "class": "td-docprintprogress" })
			.append($("<div>", { "class": "td-docprintprogress__content" })
				.text(TD.Res["document.rendering"])
				.prepend("<img align=\"absmiddle\" src=\"" + gRootURL + "/img/wait.gif\">&nbsp;"))
			.appendTo(document.body);
	}
}

function removePrintModal() {
	if (printModal) {
		printModal.remove();
		printModal = null;
	}
}

function printDocument(url) {
	var printUrl = url;
	var n = url.indexOf("?");
	if (n >= 0) {
		n++;
		var qs = $.qstring(url.substring(n));
		qs.set("print", "1");
		printUrl = url.substring(0, n) + qs.toString();
	}
	printJS({
		printable: printUrl,
		onLoadingStart: addPrintModal,
		onLoadingEnd: removePrintModal,
		onError: function () {
			// will anything happen during the print
			// simply navigate to url
			location.assign(url);
		}
	});
}

function openDocument(url) {
	// if there is a document to download, do it
	if (url) {
		var p = 0, n = url.indexOf("?");
		if (n >= 0) {
			n++;
			var qs = $.qstring(url.substr(n));
			p = qs.get("print") == "1";
			if (p) {
				qs.remove("print");
				qs.remove("back");
			}
			url = url.substring(0, n) + qs.toString();
		}
		if (p) {
			printDocument(url);
		} else if (/iP(ad|od|hone)/.test(navigator.userAgent)) {
			if (document.readyState != "complete") {
				$(window).on("load", function () {
					location.assign(url);
				});
			} else {
				location.assign(url);
			}
		} else {
			// create downloader frame
			$("<iframe>", { id: "td-downloader", src: url }).appendTo(document.body);
		}
	}
}

export { generateDocument, openDocument, printDocument };